import { CloseOutlined, ExpandMoreOutlined } from "@mui/icons-material";
import {
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { memo } from "react";

import ActiveFilterIndicator from "./ActiveFilterIndicator";

function SearchOptionGroup({
  customFalseLabel,
  customTrueLabel,
  fieldName,
  isActive,
  title,
  updateFilter,
  currentValue,
  hideFalseLabel
}) {
  const yesValue = customTrueLabel ?? "Yes";
  const noValue = customFalseLabel ?? "No";
  const label = currentValue === "true" ? yesValue : currentValue === "false" ? noValue : "";

  const handleChange = (val) => {
    updateFilter(fieldName, val);
  };

  return (
    <Accordion className="w-full bg-white">
      <AccordionSummary
        className="text-sm"
        expandIcon={
          <div className="flex items-center">
            <ExpandMoreOutlined />
          </div>
        }
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <span className="pr-2 text-black">{title}</span>
        {currentValue && (
          <div className="flex flex-row items-center">
            <span>&mdash;</span>
            <span className="mr-2 text-xs text-sky-600">&nbsp;{label}</span>
            <span> {isActive && <ActiveFilterIndicator />}</span>
          </div>
        )}
      </AccordionSummary>
      <AccordionDetails className="flex items-end justify-between w-full bg-white">
        <FormControl size="small">
          <RadioGroup
            className="text-sm bg-white"
            name="radio-buttons-group"
            value={currentValue}
            onChange={(e) => {
              handleChange(e.target.value);
            }}
          >
            <FormControlLabel
              value={true}
              control={<Radio />}
              label={yesValue}
              className="text-sm"
            />
            {!hideFalseLabel && (<FormControlLabel
              value={false}
              control={<Radio />}
              label={noValue}
              className="text-sm"
            />)
            }
          </RadioGroup>
        </FormControl>
        {String(currentValue) !== String(null) && (
          <Button
            onClick={() => handleChange(null)}
            variant="text"
            className="p-0 text-sm text-red-600 normal-case h-fit w-fit hover:bg-transparent hover:text-red-400"
          >
            Clear Filter <CloseOutlined className="ml-2" />
          </Button>
        )}
      </AccordionDetails>
    </Accordion>
  );
}

export default memo(SearchOptionGroup);
